var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from '@/setup/axios';
import { showLoading } from '@/helpers';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { trans } from '@/setup/locales';
import $ from 'jquery';
let RecipeCalculator = class RecipeCalculator extends Vue {
    constructor() {
        super(...arguments);
        this.recipes = [];
        this.recipe = null;
        this.recipesToCalculate = [];
        this.type = false;
    }
    get isValid() {
        return this.recipesToCalculate.length > 0 && this.recipesToCalculate.reduce((previous, current) => {
            return previous || current.quantity > 0;
        }, false);
    }
    mounted() {
        this.loadRecipes();
    }
    loadRecipes() {
        return __awaiter(this, void 0, void 0, function* () {
            showLoading(true);
            try {
                const { data: { recipes } } = yield axios.get(this.loadRoute);
                Object.assign(this, { recipes });
                setTimeout(() => {
                    const selectElement = document.querySelector('input.select-dropdown');
                    if (selectElement) {
                        selectElement.style.display = 'none';
                    }
                    $('#recipe').select2({
                        width: '100%',
                        data: recipes.map(recipe => {
                            return { id: recipe.id, text: recipe.reference };
                        })
                    }).on('select2:select', () => {
                        const selected = $('#recipe').select2('data').pop();
                        const id = Number(selected.id);
                        if (isNaN(id)) {
                            this.recipe = null;
                            return;
                        }
                        this.recipe = id;
                    });
                }, 500);
            }
            catch (error) {
                console.error(error);
            }
            showLoading(false);
        });
    }
    addRecipe() {
        if (this.recipe === null) {
            return;
        }
        const [recipe] = this.recipes.filter(r => r.id === this.recipe);
        this.recipesToCalculate.push({
            recipe: this.recipe,
            reference: recipe.reference,
            type: this.type ? 'bread' : 'kg',
            label: this.type ? trans('worker.correction_bread') : trans('worker.correction_weight'),
            quantity: 0,
            step: this.type ? 1 : 0.01,
        });
        this.recipe = null;
        this.$nextTick(() => {
            const input = this.$refs.inputs[this.recipesToCalculate.length - 1];
            input.focus();
        });
    }
};
__decorate([
    Prop()
], RecipeCalculator.prototype, "loadRoute", void 0);
__decorate([
    Prop()
], RecipeCalculator.prototype, "postRoute", void 0);
RecipeCalculator = __decorate([
    Component
], RecipeCalculator);
export default RecipeCalculator;
